export default __webpack_public_path__ + "static/media/santa-tree-panel-decoration.727c1a3e.png";